import PageLayer from "@/Layouts/views/PageLayer";
import PtoModalityLayer from "@/Settings/components/PtoModality/PtoModalityLayer";

// MUI
import { Stack, SvgIcon } from "@mui/material";

// Image
import { ReactComponent as Icon } from "@/assets/icons/header/settings/PtoModalityIcon.svg";

export default function PtoModalityView() {
	return (
		<PageLayer
			title="PTO Modality"
			icon={
				<Stack width={1} direction={"row"} justifyContent={"center"} alignItems={"center"}>
					<SvgIcon viewBox="-2 -2 24 24" className="text-[var(--light-blue-color)] !text-[27px]" component={Icon} />
				</Stack>
			}
		>
			<PtoModalityLayer />
		</PageLayer>
	);
}
